import { createContext } from "react";

const GroupContext = createContext(null);

export default GroupContext;